/* global fetchConfig, routes, updateFreeShippingProgress */
(function () {
  "use strict";

  // ---------------------------------------------------------------------------
  // Global: CartSemaphore + cartRequest (429 backoff, serialized access)
  // ---------------------------------------------------------------------------
  if (!window.__ptpWholesalePortalBase) {
    window.__ptpWholesalePortalBase = true;

    window.CartSemaphore = (function () {
      var locked = false;
      var queue = [];
      var safetyTimer = null;

      function runNext() {
        var next = queue.shift();
        if (typeof next === "function") {
          next();
        }
      }

      return {
        acquire: function acquire() {
          return new Promise(function (resolve) {
            function enter() {
              if (locked) {
                queue.push(enter);
                return;
              }
              locked = true;
              safetyTimer = setTimeout(function () {
                console.warn("[B2B Cart] CartSemaphore safety timeout (5s); releasing.");
                safetyTimer = null;
                locked = false;
                runNext();
              }, 5000);

              resolve(function release() {
                clearTimeout(safetyTimer);
                safetyTimer = null;
                locked = false;
                runNext();
              });
            }
            enter();
          });
        },
      };
    })();

    /**
     * @param {string} url
     * @param {RequestInit} options
     * @param {number} [retries=3]
     */
    window.cartRequest = function cartRequest(url, options, retries) {
      var maxRetries = typeof retries === "number" ? retries : 3;
      return window.CartSemaphore.acquire().then(function (release) {
        function attempt(i) {
          return fetch(url, options).then(function (response) {
            if (response.status === 429 && i < maxRetries) {
              return new Promise(function (r) {
                setTimeout(function () {
                  r(attempt(i + 1));
                }, Math.pow(2, i) * 300);
              });
            }
            return response;
          });
        }
        return attempt(0).finally(function () {
          if (typeof release === "function") {
            release();
          }
        });
      });
    };
  }

  function isB2BCartStabilitySession() {
    return window.__ptpCustomerB2b === true;
  }

  /**
   * DOMContentLoaded order:
   * 1) Capture-phase listeners (neutralize theme/Rebuy duplicate handlers)
   * 2) CartSemaphore + cartRequest (already on window)
   * 3) Bind B2B cart events
   * 4) Trailing debounce (500ms, leading: false) on quantity commits
   */
  function bootB2BCartStability() {
    if (!isB2BCartStabilitySession()) {
      return;
    }
    if (window.__b2bCartStabilityBootComplete) {
      return;
    }
    window.__b2bCartStabilityBootComplete = true;

    var debounceTimers = new WeakMap();

    function getSectionsToRender() {
      var list = [];
      var mainItems = document.getElementById("main-cart-items");
      var mainFooter = document.getElementById("main-cart-footer");

      if (mainItems && mainItems.dataset && mainItems.dataset.id) {
        list.push({ id: "main-cart-items", section: mainItems.dataset.id, selector: ".js-contents" });
      }
      if (mainFooter && mainFooter.dataset && mainFooter.dataset.id) {
        list.push({ id: "main-cart-footer", section: mainFooter.dataset.id, selector: ".js-contents" });
      }

      var bubble = document.getElementById("cart-icon-bubble");
      if (bubble) {
        list.push({ id: "cart-icon-bubble", section: "cart-icon-bubble", selector: ".shopify-section" });
      }
      var live = document.getElementById("cart-live-region-text");
      if (live) {
        list.push({ id: "cart-live-region-text", section: "cart-live-region-text", selector: ".shopify-section" });
      }
      return list;
    }

    function getSectionInnerHTML(html, selector) {
      var doc = new DOMParser().parseFromString(html, "text/html");
      var node = doc.querySelector(selector);
      return node ? node.innerHTML : "";
    }

    function performCartQuantityUpdate(input, line, quantity, nameAttr) {
      if (!input || input.dataset.processing === "true") {
        return;
      }
      if (!window.routes || !window.routes.cart_change_url) {
        return;
      }

      input.dataset.processing = "true";
      var mainCart = document.getElementById("main-cart-items");
      if (mainCart) {
        mainCart.classList.add("cart__items--disabled");
      }

      var sections = getSectionsToRender();
      var sectionIds = sections.map(function (s) {
        return s.section;
      });

      var body = JSON.stringify({
        line: line,
        quantity: String(quantity),
        sections: sectionIds,
        sections_url: window.location.pathname,
      });

      var config = Object.assign(
        {},
        typeof fetchConfig === "function" ? fetchConfig() : { method: "POST", headers: {} },
        { body: body }
      );
      if (!config.headers) {
        config.headers = {};
      }
      config.headers["Content-Type"] = "application/json";
      config.headers.Accept = "application/json";

      window
        .cartRequest(window.routes.cart_change_url, config, 3)
        .then(function (response) {
          return response.text().then(function (text) {
            return { response: response, text: text };
          });
        })
        .then(function (pack) {
          if (!pack.response.ok) {
            throw new Error("Cart change failed: " + pack.response.status);
          }
          var parsed = JSON.parse(pack.text);
          var cartItemsEl = document.querySelector("cart-items");
          if (cartItemsEl) {
            cartItemsEl.classList.toggle("is-empty", parsed.item_count === 0);
          }
          var footer = document.getElementById("main-cart-footer");
          if (footer) {
            footer.classList.toggle("is-empty", parsed.item_count === 0);
          }

          sections.forEach(function (section) {
            var root = document.getElementById(section.id);
            if (!root || !parsed.sections || !parsed.sections[section.section]) {
              return;
            }
            var html = parsed.sections[section.section];
            var replaceRoot = root.querySelector(section.selector) || root;
            var inner = getSectionInnerHTML(html, section.selector);
            if (inner) {
              replaceRoot.innerHTML = inner;
            }
          });

          if (typeof updateFreeShippingProgress === "function") {
            updateFreeShippingProgress(document);
          }
          document.dispatchEvent(new CustomEvent("b2b:cart-silent-updated"));

          var qtyInputFocus = document.getElementById("Quantity-" + line);
          if (qtyInputFocus && typeof qtyInputFocus.focus === "function") {
            qtyInputFocus.focus();
          }
        })
        .catch(function (err) {
          console.error("[B2B Cart] Quantity update failed:", err);
          var errBox = document.getElementById("cart-errors");
          if (errBox && window.cartStrings && window.cartStrings.error) {
            errBox.textContent = window.cartStrings.error;
          }
        })
        .finally(function () {
          input.dataset.processing = "false";
          if (mainCart) {
            mainCart.classList.remove("cart__items--disabled");
          }
        });
    }

    function scheduleTrailingDebounceQuantity(input, line, quantity, nameAttr) {
      var prev = debounceTimers.get(input);
      if (prev) {
        clearTimeout(prev);
      }
      var timerId = setTimeout(function () {
        debounceTimers.delete(input);
        performCartQuantityUpdate(input, line, quantity, nameAttr);
      }, 500);
      debounceTimers.set(input, timerId);
    }

    // 1 + 3 + 4: capture phase + trailing debounce (leading: false implicit)
    document.addEventListener(
      "change",
      function (event) {
        if (!isB2BCartStabilitySession()) {
          return;
        }
        var target = event.target;
        if (!target || target.name !== "updates[]") {
          return;
        }
        if (!target.closest || !target.closest("cart-items")) {
          return;
        }

        if (window.__ptpCustomerB2b === true) {
          event.stopImmediatePropagation();
          event.preventDefault();
        }

        if (target.dataset.processing === "true") {
          return;
        }

        var line = target.dataset.index;
        if (line === undefined || line === null) {
          return;
        }
        var quantity = target.value;
        var nameAttr = target.getAttribute("name") || "updates[]";

        scheduleTrailingDebounceQuantity(target, line, quantity, nameAttr);
      },
      true
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootB2BCartStability);
  } else {
    bootB2BCartStability();
  }

  // ---------------------------------------------------------------------------
  // B2B Quick Order page: suppress stray drawer UI only (no Corso / cart math)
  // ---------------------------------------------------------------------------
  var scope = document.querySelector(".b2b-qo-scope");
  if (!scope) {
    return;
  }
  if (window.__b2bQuickOrderMinimalInit) {
    return;
  }
  window.__b2bQuickOrderMinimalInit = true;

  var isNativeB2BSession =
    window.__ptpCustomerB2b === true ||
    document.documentElement.classList.contains("b2b-native-session") ||
    document.body.classList.contains("b2b-native-session");

  function hardSuppressDrawerUI() {
    document.body.classList.remove("modal-open");
    document.documentElement.classList.remove("modal-open");
    document
      .querySelectorAll(".rebuy-cart__overlay, #rebuy-cart-drawer, .cart-drawer, .cart-notification, [id*='rebuy']")
      .forEach(function (el) {
        el.style.setProperty("display", "none", "important");
        el.style.setProperty("visibility", "hidden", "important");
        el.style.setProperty("pointer-events", "none", "important");
      });
  }

  document.addEventListener("b2b:cart-silent-updated", function () {
    if (isNativeB2BSession) {
      hardSuppressDrawerUI();
    }
  });

  if (isNativeB2BSession) {
    hardSuppressDrawerUI();
  }
})();
